import type { DataOption } from '@/shared/components/HookForm/types'

import { useCompetitorsOptionsQuery } from '@/entities/core'

/**
 * Global competitor list mapped to `{ value: competitor_id, label: name }` for
 * the campaign competitor fields (specs/005, Q2: global — no OG scoping).
 * Shared by `CompetitorListField`; TanStack dedupes.
 */
export const useCompetitorOptions = ({
	context,
}: {
	context?: {
		optimizationGroupId?: string
	}
}) => {
	const query = useCompetitorsOptionsQuery<DataOption[]>(
		{
			limit: 0,
			order_by: 'name',
			optimization_group_id: context?.optimizationGroupId,
		},
		{
			select: (data) =>
				(data.objects ?? [])
					.filter((c) => !!c.competitor_id && !!c.name)
					.map((c) => ({ value: c.name!, label: c.name! })),
		}
	)

	return {
		options: query.data ?? [],
		isLoading: query.isLoading,
		isError: query.isError,
		refetch: query.refetch,
	}
}
